/**
 * @file The select album folder purchase pre-purchase container.
 */

import { connect } from 'react-redux';

import AlbumFolderPurchasePrePurchase from '../../../components/purchase/album-folder-purchase/AlbumFolderPurchasePrePurchase';
import { openModal } from '../../../actions/modal-actions';

const mapDispatchToProps = {
  openModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(AlbumFolderPurchasePrePurchase);
